import React from 'react';
import { X } from 'lucide-react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
interface AdminCreatePanelProps {
  createPanel: {
    type: string;
    title: string;
  } | null;
  setCreatePanel: (panel: any) => void;
  newContentForm: any;
  setNewContentForm: (form: any) => void;
  handleCreateContent: () => void;
  newPromoForm: any;
  setNewPromoForm: (form: any) => void;
  handleCreatePromo: () => void;
  newCampaignForm: any;
  setNewCampaignForm: (form: any) => void;
  handleCreateCampaign: () => void;
  newAstrologerForm: any;
  setNewAstrologerForm: (form: any) => void;
  handleCreateAstrologer: () => void;
  newOrderForm: any;
  setNewOrderForm: (form: any) => void;
  handleCreateOrder: () => void;
  newAiReportForm: any;
  setNewAiReportForm: (form: any) => void;
  handleCreateAiReport: () => void;
  newAdForm: any;
  setNewAdForm: (form: any) => void;
  handleCreateAd: () => void;
  newEventForm: any;
  setNewEventForm: (form: any) => void;
  handleCreateEvent: () => void;
  newServiceForm: any;
  setNewServiceForm: (form: any) => void;
  handleCreateService: () => void;
  success: (msg: string) => void;
}
export function AdminCreatePanel({
  createPanel,
  setCreatePanel,
  newContentForm,
  setNewContentForm,
  handleCreateContent,
  newPromoForm,
  setNewPromoForm,
  handleCreatePromo,
  newCampaignForm,
  setNewCampaignForm,
  handleCreateCampaign,
  newAstrologerForm,
  setNewAstrologerForm,
  handleCreateAstrologer,
  newOrderForm,
  setNewOrderForm,
  handleCreateOrder,
  newAiReportForm,
  setNewAiReportForm,
  handleCreateAiReport,
  newAdForm,
  setNewAdForm,
  handleCreateAd,
  newEventForm,
  setNewEventForm,
  handleCreateEvent,
  newServiceForm,
  setNewServiceForm,
  handleCreateService,
  success
}: AdminCreatePanelProps) {
  if (!createPanel) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/20 backdrop-blur-sm" onClick={e => {
    if (e.target === e.currentTarget) setCreatePanel(null);
  }} data-id="element-3036">
      <div className="w-full max-w-sm bg-white rounded-xl shadow-2xl flex flex-col max-h-[90vh]" data-id="element-3037">
        <div className="h-12 border-b border-slate-100 flex items-center justify-between px-5 bg-slate-50/50 rounded-t-xl" data-id="element-3038">
          <h3 className="text-sm font-bold text-slate-900" data-id="element-3039">
            {createPanel.title}
          </h3>
          <button className="p-1.5 text-slate-400 hover:text-slate-600 rounded-md hover:bg-slate-100" onClick={() => setCreatePanel(null)} data-id="element-3040">
            <X className="w-4 h-4" data-id="element-3041" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5 space-y-4" data-id="element-3042">
          {createPanel.type === 'content' && <>
              <Input label="Заголовок" value={newContentForm.title} onChange={e => setNewContentForm({
            ...newContentForm,
            title: e.target.value
          })} data-id="element-3043" />
              <div data-id="element-3044">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-3045">
                  Тип
                </label>
                <select className="w-full rounded-xl border-slate-200 shadow-sm px-3 py-2 border outline-none text-xs" value={newContentForm.type} onChange={e => setNewContentForm({
              ...newContentForm,
              type: e.target.value
            })} data-id="element-3046">
                  <option data-id="element-3047">Статья блога</option>
                  <option data-id="element-3048">Страница</option>
                  <option data-id="element-3049">FAQ</option>
                </select>
              </div>
              <Button variant="primary" className="w-full" onClick={handleCreateContent} data-id="element-3050">
                Создать
              </Button>
            </>}
          {createPanel.type === 'promo' && <>
              <Input label="Код" value={newPromoForm.code} onChange={e => setNewPromoForm({
            ...newPromoForm,
            code: e.target.value
          })} data-id="element-3051" />
              <Input label="Скидка" placeholder="Например: 20% или 500 ₽" value={newPromoForm.discount} onChange={e => setNewPromoForm({
            ...newPromoForm,
            discount: e.target.value
          })} data-id="element-3052" />
              <Input label="Лимит использований" placeholder="Оставьте пустым для безлимита" value={newPromoForm.limit} onChange={e => setNewPromoForm({
            ...newPromoForm,
            limit: e.target.value
          })} data-id="element-3053" />
              <Button variant="primary" className="w-full" onClick={handleCreatePromo} data-id="element-3054">
                Создать
              </Button>
            </>}
          {createPanel.type === 'campaign' && <>
              <Input label="Название рассылки" value={newCampaignForm.name} onChange={e => setNewCampaignForm({
            ...newCampaignForm,
            name: e.target.value
          })} data-id="element-3055" />
              <Input label="Тема письма" value={newCampaignForm.subject} onChange={e => setNewCampaignForm({
            ...newCampaignForm,
            subject: e.target.value
          })} data-id="element-3056" />
              <Button variant="primary" className="w-full" onClick={handleCreateCampaign} data-id="element-3057">
                Создать
              </Button>
            </>}
          {createPanel.type === 'astrologer' && <>
              <Input label="Имя" value={newAstrologerForm.name} onChange={e => setNewAstrologerForm({
            ...newAstrologerForm,
            name: e.target.value
          })} data-id="element-3058" />
              <Input label="Email" type="email" value={newAstrologerForm.email} onChange={e => setNewAstrologerForm({
            ...newAstrologerForm,
            email: e.target.value
          })} data-id="element-3059" />
              <div data-id="element-3060">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-3061">
                  Специализация
                </label>
                <select className="w-full rounded-xl border-slate-200 shadow-sm px-3 py-2 border outline-none text-xs" value={newAstrologerForm.spec} onChange={e => setNewAstrologerForm({
              ...newAstrologerForm,
              spec: e.target.value
            })} data-id="element-3062">
                  <option data-id="element-3063">Натальная астрология</option>
                  <option data-id="element-3064">Ведическая астрология</option>
                  <option data-id="element-3065">Таро</option>
                  <option data-id="element-3066">Нумерология</option>
                </select>
              </div>
              <Button variant="primary" className="w-full" onClick={handleCreateAstrologer} data-id="element-3067">
                Добавить
              </Button>
            </>}
          {createPanel.type === 'order' && <>
              <Input label="Клиент" value={newOrderForm.client} onChange={e => setNewOrderForm({
            ...newOrderForm,
            client: e.target.value
          })} data-id="element-3068" />
              <div data-id="element-3069">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-3070">
                  Услуга
                </label>
                <select className="w-full rounded-xl border-slate-200 shadow-sm px-3 py-2 border outline-none text-xs" value={newOrderForm.service} onChange={e => setNewOrderForm({
              ...newOrderForm,
              service: e.target.value
            })} data-id="element-3071">
                  <option data-id="element-3072">Натальная карта</option>
                  <option data-id="element-3073">Соляр</option>
                  <option data-id="element-3074">Синастрия</option>
                  <option data-id="element-3075">Консультация (Видео)</option>
                </select>
              </div>
              <Input label="Сумма" placeholder="Например: 3 900 ₽" value={newOrderForm.amount} onChange={e => setNewOrderForm({
            ...newOrderForm,
            amount: e.target.value
          })} data-id="element-3076" />
              <Button variant="primary" className="w-full" onClick={handleCreateOrder} data-id="element-3077">
                Создать заказ
              </Button>
            </>}
          {createPanel.type === 'ai_report' && <>
              <div data-id="element-3078">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-3079">
                  Тип отчёта
                </label>
                <select className="w-full rounded-xl border-slate-200 shadow-sm px-3 py-2 border outline-none text-xs" value={newAiReportForm.type} onChange={e => setNewAiReportForm({
              ...newAiReportForm,
              type: e.target.value
            })} data-id="element-3080">
                  <option data-id="element-3081">Натальная карта</option>
                  <option data-id="element-3082">Соляр</option>
                  <option data-id="element-3083">Совместимость</option>
                  <option data-id="element-3084">Прогноз транзитов</option>
                </select>
              </div>
              <Input label="Клиент (Имя)" value={newAiReportForm.client} onChange={e => setNewAiReportForm({
            ...newAiReportForm,
            client: e.target.value
          })} data-id="element-3085" />
              <Input label="Дата и время рождения" placeholder="ДД.ММ.ГГГГ ЧЧ:ММ" value={newAiReportForm.birthDate} onChange={e => setNewAiReportForm({
            ...newAiReportForm,
            birthDate: e.target.value
          })} data-id="element-3086" />
              <Input label="Место рождения" value={newAiReportForm.birthPlace} onChange={e => setNewAiReportForm({
            ...newAiReportForm,
            birthPlace: e.target.value
          })} data-id="element-3087" />
              <Button variant="primary" className="w-full" onClick={handleCreateAiReport} data-id="element-3088">
                Сгенерировать
              </Button>
            </>}
          {createPanel.type === 'ad' && <>
              <Input label="Название кампании" value={newAdForm.name} onChange={e => setNewAdForm({
            ...newAdForm,
            name: e.target.value
          })} data-id="element-3089" />
              <div data-id="element-3090">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-3091">
                  Тип
                </label>
                <select className="w-full rounded-xl border-slate-200 shadow-sm px-3 py-2 border outline-none text-xs" value={newAdForm.type} onChange={e => setNewAdForm({
              ...newAdForm,
              type: e.target.value
            })} data-id="element-3092">
                  <option data-id="element-3093">Баннер</option>
                  <option data-id="element-3094">Нативная</option>
                  <option data-id="element-3095">Попап</option>
                </select>
              </div>
              <Input label="Бюджет" placeholder="Например: 10 000 ₽" value={newAdForm.budget} onChange={e => setNewAdForm({
            ...newAdForm,
            budget: e.target.value
          })} data-id="element-3096" />
              <Button variant="primary" className="w-full" onClick={handleCreateAd} data-id="element-3097">
                Запустить
              </Button>
            </>}
          {createPanel.type === 'event' && <>
              <Input label="Название события" value={newEventForm.title} onChange={e => setNewEventForm({
            ...newEventForm,
            title: e.target.value
          })} data-id="element-3098" />
              <div data-id="element-3099">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-3100">
                  Тип
                </label>
                <select className="w-full rounded-xl border-slate-200 shadow-sm px-3 py-2 border outline-none text-xs" value={newEventForm.type} onChange={e => setNewEventForm({
              ...newEventForm,
              type: e.target.value
            })} data-id="element-3101">
                  <option data-id="element-3102">Затмение</option>
                  <option data-id="element-3103">Полнолуние</option>
                  <option data-id="element-3104">Новолуние</option>
                  <option data-id="element-3105">Ретроград</option>
                </select>
              </div>
              <Input label="Дата" type="date" value={newEventForm.date} onChange={e => setNewEventForm({
            ...newEventForm,
            date: e.target.value
          })} data-id="element-3106" />
              <Input label="Знак зодиака" value={newEventForm.zodiac} onChange={e => setNewEventForm({
            ...newEventForm,
            zodiac: e.target.value
          })} data-id="element-3107" />
              <Button variant="primary" className="w-full" onClick={handleCreateEvent} data-id="element-3108">
                Добавить
              </Button>
            </>}
          {createPanel.type === 'service' && <>
              <Input label="Название услуги" value={newServiceForm.title} onChange={e => setNewServiceForm({
            ...newServiceForm,
            title: e.target.value
          })} data-id="element-3109" />
              <div data-id="element-3110">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-3111">
                  Тип
                </label>
                <select className="w-full rounded-xl border-slate-200 shadow-sm px-3 py-2 border outline-none text-xs" value={newServiceForm.type} onChange={e => setNewServiceForm({
              ...newServiceForm,
              type: e.target.value
            })} data-id="element-3112">
                  <option data-id="element-3113">Авто-отчёт</option>
                  <option data-id="element-3114">Услуга астролога</option>
                  <option data-id="element-3115">Подписка</option>
                </select>
              </div>
              <Input label="Цена" placeholder="Например: 3 900 ₽" value={newServiceForm.price} onChange={e => setNewServiceForm({
            ...newServiceForm,
            price: e.target.value
          })} data-id="element-3116" />
              <Button variant="primary" className="w-full" onClick={handleCreateService} data-id="element-3117">
                Сохранить
              </Button>
            </>}
          {createPanel.type === 'user' && <>
              <Input label="Имя" placeholder="Иван Иванов" data-id="element-3118" />
              <Input label="Email" type="email" placeholder="ivan@example.com" data-id="element-3119" />
              <Input label="Телефон" placeholder="+7 (999) 000-00-00" data-id="element-3120" />
              <Button variant="primary" className="w-full" onClick={() => {
            setCreatePanel(null);
            success('Пользователь добавлен');
          }} data-id="element-3121">
                Добавить пользователя
              </Button>
            </>}
        </div>
      </div>
    </div>;
}